import apiService from '../../../services/api-client';
import { DeleteLocationResponse } from '../interfaces/delete-location';
import { GetLocationsResponse } from '../interfaces/get-locations';
import { PostLocationPayloadRequest, PostLocationResponse } from '../interfaces/post-location';
import { PutLocationPayloadRequest, PutLocationResponse } from '../interfaces/put-location';

export const locationApiService = {
  async getLocations(id: number, filters?: {
    code?: string;
    warehouse_code?: string;
    location_type_id?: string;
    channel_type_id?: string;
  }) {
    const params = new URLSearchParams();
    if (filters?.code) params.append('code', filters.code);
    if (filters?.warehouse_code) params.append('warehouse_code', filters.warehouse_code);
    if (filters?.location_type_id) params.append('location_type_id', filters.location_type_id);
    if (filters?.channel_type_id) params.append('channel_type_id', filters.channel_type_id);
    
    const { data } = await apiService().get<GetLocationsResponse>(`company/${id}/locations`, {
      params
    });
    return data;
  },
  async postLocation(id: number, body: PostLocationPayloadRequest) {
    const { data } = await apiService().post<PostLocationResponse>(`company/${id}/location`, body);
    return data;
  },
  async putLocation(cId: number, pId: number, body: PutLocationPayloadRequest) {
    const { data } = await apiService().put<PutLocationResponse>(
      `company/${cId}/location/${pId}`,
      body
    );
    return data;
  },
  async deleteLocation(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteLocationResponse>(
      `company/${cId}/location/${pId}`
    );
    return data;
  },
};
